const { REACT_APP_BASE_URL } = process.env;

// Usa a variável de ambiente prefixada (CRA expõe apenas REACT_APP_*)
// e faz fallback para localhost caso não esteja definida.
export const API_BASE_URL =
    REACT_APP_BASE_URL && REACT_APP_BASE_URL.trim().length > 0
        ? REACT_APP_BASE_URL
        : "http://localhost:8080";

